import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface GlobalSiteState {
  mainMenuOpen: boolean;
  toggleMainMenuState: () => void;
}

export const useGlobalSiteSettings = create<GlobalSiteState>()(
  persist(
    (set) => ({
      mainMenuOpen: true,
      toggleMainMenuState: () =>
        set((state) => ({ mainMenuOpen: !state.mainMenuOpen })),
    }),
    { name: 'global-settings-store' },
  ),
);
